// import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
@Component({
  selector: 'app-discussion-board-ask-page',
  templateUrl: './discussion-board-ask-page.component.html',
  styleUrls: ['./discussion-board-ask-page.component.scss'],
})
export class DiscussionBoardAskPageComponent implements OnInit {
  askquestionform: FormGroup;
  submitted = false;

  disable = false;
  response;

  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  today = new Date();
  @ViewChild('inputFile') myInputVariable: ElementRef;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    // this.askquestionform = this.fb.group({
    //   questionTitle: ['', [Validators.required]],
    //   quetionDiscription: ['', [Validators.required]],
    //   attachlink: ['', [Validators.pattern(this.reg)]],
    //   Image: ['', [Validators.required]],
    // });
    this.askquestionform = this.fb.group({
      // questionTitle: ['', [Validators.minLength(20),Validators.maxLength(60)]],
      questionTitle: ['', [Validators.minLength(20), Validators.maxLength(60)]],
      quetionDiscription: [
        '',
        [Validators.required, Validators.maxLength(400)],
      ],
      attachlink: ['', [Validators.pattern(this.reg)]],
      // Image: ['', [Validators.required]],
      Image: ['', []],
    });
  }

  get questionTitle() {
    return this.askquestionform.get('questionTitle');
  }

  get quetionDiscription() {
    return this.askquestionform.get('quetionDiscription');
  }
  get attach_url() {
    return this.askquestionform.get('attachlink');
  }
  // new code

  savescheme = false;
  processImage1(event) {
    this.isButtonVisible = true;
    // let files: FileList = event.target.files;
    // this.file1  = files[0];
    let splitfile = event.target.files[0].type;
    let type = splitfile.split('/');

    if (
      type[1] == 'jpeg' ||
      type[1] == 'jpg' ||
      type[1] == 'png' ||
      type[1] == 'pdf'
    ) {
      this.finaldata = this.file1;
      //this.file2 = this.file1;
      this.savescheme = true;
    }
    // else {
    //   this.finaldata = 0;
    //   this.myInputVariable.nativeElement.value = "";
    //   this.savescheme = false;
    //   this.isButtonVisible = false;
    //   this.toastr.warning("Accepted File Formats PDF,PNG.JPG and JPEG only", 'Info', {
    //     timeOut: 3000,
    //   });
    //   //this.file2 = null;
    //   return;
    // }

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: FileList = event.target.files;
    this.file1 = files[0];
    const fileSize = Math.round(this.file1.size / 1024);
    if (fileSize > 5120) {
      // if (this.file1.size >= 4096) {
      this.myInputVariable.nativeElement.value = '';
      this.askquestionform.value.Image = '';
      this.toastr.warning('Accepted  file Size should be below 5MB', 'Info', {
        timeOut: 3000,
      });
    } else {
      this.finaldata = this.file1;
      this.savescheme = true;
    }
  }

  onSubmit1() {
    let myfile = this.finaldata;

    // if (this.askquestionform.value.questionTitle === "" && this.askquestionform.value.Image==="") {
    if (this.askquestionform.value.questionTitle === '') {
      alert('Please fill all mandatory fields and enter valid values');
      return;
    } else if (this.askquestionform.value.questionTitle === '') {
      alert('Please enter the title');
      return;
    }
    //  else if(this.askquestionform.value.Image==="" || this.askquestionform.value.Image===null) {
    //   alert('Please choose an image file or video file should be less than 5MB')
    //   this.askquestionform.value.Image = "";
    //   this.removeFile();
    // return;
    //  }
    else {
      const postdata = new FormData();
      postdata.append('Title', this.askquestionform.value.questionTitle);
      // if (this.askquestionform.value.questionTitle == "" || this.askquestionform.value.quetionDiscription == "" || this.askquestionform.value.Image == "")
      if (
        this.askquestionform.value.questionTitle == '' ||
        this.askquestionform.value.quetionDiscription == '' ||
        this.askquestionform.value.questionTitle === null ||
        this.askquestionform.value.quetionDiscription === null
      ) {
        alert('Please Enter Mandatory fields');
      } else {
        let text = confirm('Are you sure you want to publish this new Post ?');
        if (text == true) {
          this.spinner.show();
          postdata.append(
            'Content',
            this.askquestionform.value.quetionDiscription
          );
          postdata.append('Image', this.finaldata);
          this._userService.postCreatequestion(postdata).subscribe((data) => {
            this.response = data;
            this.spinner.hide();
            // var message:any = response.result.data
            // alert(message.message);
            this.askquestionform.value.questionTitle = '';
            this.askquestionform.value.Image = '';
            this.removeFile();
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          });
          this.removeFile();
          this.askquestionform.reset();
          this.spinner.hide();
          // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          //   this.router.navigate(['/Govt-schemes']);
          // });
        } else {
          //  return false;
        }
      }
    }

    // window.location.reload();
  }

  // new code end

  listPage() {
    this.router.navigate(['/discussionboard']);
  }

  guidelinePage() {
    this.router.navigate(['/discussionboard-guidelines']);
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }
  closeAskPost() {
    this.askquestionform.reset();
  }

  fileData;
  finaldata;
  lastFilePath: any;
  file1: any;
  isButtonVisible = false;
  processImage(event) {
    this.isButtonVisible = true;
    let splitfile = event.target.files;

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: [] = event.target.files;
    this.file1 = [];
    // video file

    for (let i = 0; i < splitfile.length; i++) {
      let type = splitfile[i].type.split('/');
      // if (!(type[1] == "jpeg" || type[1] == "jpg" || type[1] == "png")) {

      //   this.finaldata = 0
      //   this.myInputVariable.nativeElement.value = "";
      //   // this.savescheme = false;
      //   this.isButtonVisible = false;
      //   this.toastr.warning("Accepted File Formats PNG.JPG and JPEG only", 'Info', {
      //     timeOut: 3000,
      //   });
      //   return;
      // }
      // else
      if (splitfile[i].size >= 5242900) {
        this.myInputVariable.nativeElement.value = '';
        this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
          timeOut: 3000,
        });
        return;
      } else {
        this.file1.push(splitfile[i]);
      }
    }
    this.finaldata = this.file1;
    // this.savescheme = true;
    // this.submit_file();
  }

  removeFile() {
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }
}
